import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Text } from '@fragments';
import './styles.scss';

// The reveal's clip reaches past the word's box, so the italic's overhang and the
// underline hanging below it are never cut.
const write = { initial: { clipPath: 'inset(-25% 100% -45% 0%)', opacity: 1 }, animate: { clipPath: 'inset(-25% -12% -45% 0%)', opacity: 1 }, exit: { opacity: 0 },
  transition: { clipPath: { duration: 1.15, ease: 'linear' }, opacity: { duration: 0.2 } } };
const underline = { initial: { pathLength: 0 }, animate: { pathLength: 1 }, transition: { delay: 1.05, duration: 0.45 } };

// `inline` writes the word inside a running line (the landing title): no reserved
// width, so the line re-centers while the next word is still unwritten. `label`
// is what it reads as (screen readers, reduced motion), the words joined by default.
export default function InterestReel({ interests, inline = false, label }) {
  const reduced = useReducedMotion();
  const words = [...new Set(interests.filter(Boolean))];
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (reduced || words.length < 2) return undefined;
    const timer = setInterval(() => {
      if (!document.hidden) setIndex(current => (current + 1) % words.length);
    }, 3400);
    return () => clearInterval(timer);
  }, [reduced, words.length]);

  const word = words[index % words.length];
  if (inline) {
    const still = reduced || words.length < 2;
    const text = still && words.length > 1 ? (label || words.join(' · ')) : word;
    return <span className="studio-interest-reel is-inline">
      {!still && <Text.span className="studio-visually-hidden">{label || words.join(' · ')}</Text.span>}
      <AnimatePresence mode="wait">
        <motion.span key={text} className="studio-interest-reel__word" aria-hidden={still ? undefined : 'true'} {...(reduced ? {} : write)}>
          <Text.span className="studio-interest-word">{text}</Text.span>
          <svg className="studio-interest-reel__underline" viewBox="0 0 160 10" preserveAspectRatio="none" aria-hidden="true"><motion.path d="M2 7 Q76 1 157 5" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" {...(reduced ? {} : underline)} /></svg>
        </motion.span>
      </AnimatePresence>
    </span>;
  }
  if (reduced || words.length < 2) return <Text.span className="studio-interest-word">{words.join(' · ')}</Text.span>;
  return <div className="studio-interest-reel">
    <Text.span className="studio-visually-hidden">{words.join(' · ')}</Text.span>
    <div className="studio-interest-reel__sizer" aria-hidden="true">{words.map(item => <Text.span className="studio-interest-word" key={item}>{item}</Text.span>)}</div>
    <div className="studio-interest-reel__writing" aria-hidden="true">
      <AnimatePresence mode="wait">
        <motion.div key={word} {...write}>
          <Text.span className="studio-interest-word">{word}</Text.span>
          <svg className="studio-interest-reel__underline" viewBox="0 0 160 10" preserveAspectRatio="none"><motion.path d="M2 7 Q76 1 157 5" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" {...underline} /></svg>
        </motion.div>
      </AnimatePresence>
    </div>
  </div>;
}
